const SearchResultAtlasProject = `
... on SearchResultAtlasProject @include(if: $includeAtlasProjects) {
  project {
    __typename
    key
  }
}
`;

const SearchResultAtlasGoal = `
... on SearchResultAtlasGoal @include(if: $includeAtlasGoals) {
  goal {
    __typename
    key
  }
}
`;

const SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;

export const operationName = 'QuickFindSearchQuery';
export const quickFindSearchGraphQuery: '\n  query QuickFindSearchQuery(\n    $query: String!\n    $cloudIdARI: String!\n    $resultsLimit: Int!\n    $spaceLimit: Int!\n    $contentEntities: [String!]!\n    $confluenceFilters: SearchConfluenceFilter\n    $queryVersion: Int\n    $searchSessionId: String\n    $includeSpaces: Boolean!\n    $includeAncestors: Boolean!\n\t\t$includeAtlasProjects: Boolean = true\n    $includeAtlasGoals: Boolean = true\n    $experimentId: String\n    $shadowExperimentId: String\n    $experimentLayers: [SearchExperimentLayer]\n\t\t$experience: String = "quick-find"\n\t\t$spacesExperience: String = "searchDialog"\n  ) {\n    search {\n      results: search(\n        experience: $experience\n        query: $query\n        first: $resultsLimit\n        filters: {\n          entities: $contentEntities\n          locations: [$cloudIdARI]\n          confluenceFilters: $confluenceFilters\n        }\n        analytics: {\n          queryVersion: $queryVersion\n          searchSessionId: $searchSessionId\n        }\n        experimentContext: {\n          experimentId: $experimentId\n          shadowExperimentId: $shadowExperimentId\n          experimentLayers: $experimentLayers\n        }\n      ) {\n        __typename\n        edges {\n          __typename\n          node {\n            id\n            title\n            url\n            type\n            iconUrl\n            __typename\n            \n... on SearchConfluencePageBlogAttachment {\n  __typename\n  lastModified\n  iconCssClass\n  space {\n    __typename\n    id\n    name\n  }\n  confluenceEntity @include(if: $includeAncestors) {\n    ... on ConfluencePage {\n      __typename\n      ancestors {\n        __typename\n        id\n        title\n      }\n    }\n  }\n}\n\t\t\t\t\t\t\n... on SearchResultAtlasProject @include(if: $includeAtlasProjects) {\n  project {\n    __typename\n    key\n  }\n}\n\n\t\t\t\t\t\t\n... on SearchResultAtlasGoal @include(if: $includeAtlasGoals) {\n  goal {\n    __typename\n    key\n  }\n}\n\n          }\n        }\n        abTest {\n          __typename\n          abTestId\n          controlId\n          experimentId\n        }\n        totalCount\n      }\n      spaces: search(\n\t\t\t\texperience: $spacesExperience\n        query: $query\n        first: $spaceLimit\n        filters: {\n          entities: ["ati:cloud:confluence:space"]\n          locations: [$cloudIdARI]\n        }\n        analytics: {\n          queryVersion: $queryVersion\n          searchSessionId: $searchSessionId\n        }\n      ) @include(if: $includeSpaces) {\n        __typename\n        edges {\n          __typename\n          node {\n            ... on SearchConfluenceSpace {\n              __typename\n              id\n              key\n              title\n              type\n              url\n              iconPath\n            }\n          }\n        }\n      }\n    }\n  }\n' = `
  query ${operationName}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
		$includeAtlasProjects: Boolean = true
    $includeAtlasGoals: Boolean = true
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
		$experience: String = "quick-find"
		$spacesExperience: String = "searchDialog"
  ) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${SearchConfluencePageBlogAttachment}
						${SearchResultAtlasProject}
						${SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
				experience: $spacesExperience
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;
